export default "assets/images/icons/user-fa9fcc3a.svg";